import React from 'react';
import SigmaModal from '../../../../Pages/Modal';
import BulkCursoTab from '../AsignacionCursosArea/BulkCursoTab';

export default function AsignarCursosTurnoModal({ open, turno, onClose }) {
    if (!open || !turno) return null;

    return (
        <SigmaModal
            open={open}
            title={`Cursos para el Turno: ${turno.nombre}`}
            onClose={onClose}
            modalWidth="min(1100px, 95vw)"
            hideFooter={true}
            hideHeaderPrefix={true}
        >
            <div className="roles-editor-slot" style={{ marginTop: '0' }}>
                <BulkCursoTab
                    type="turno"
                    fkId={turno.idTurno}
                    onClose={onClose}
                />
            </div>
        </SigmaModal>
    );
}
